import { Heading, Link, Text } from "@RooUI";
import React, { useEffect } from "react";

import HeaderLogIn from "../../Login/HeaderLogIn";
import bookingConfirmedImg from "../../static/images/booking-confirmed.png";
import { Event, EventTracker } from "../../tracking/service/EventTracker/EventTrackerService";
import { useRegistrationContext } from "../registrationContext";
import { PageContainer } from "../styles";

import { BookingConfirmedContainer } from "./styles";

function RegistrationComplete() {
  const { registrationContext } = useRegistrationContext();
  const { isRooState, hospitalId } = registrationContext;
  useEffect(() => {
    EventTracker.send({
      eventName: isRooState
        ? Event.Name.HOSPITAL_REGISTRATION_SUCCESS
        : Event.Name.HOSPITAL_REGISTRATION_SUCCESS_INACTIVE_MARKET,
      eventType: Event.Type.PAGE_VIEW,
      entityType: Event.Entity.HOSPITAL,
      entityId: hospitalId,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <PageContainer className="inner-container">
      <HeaderLogIn showLogout={true} />
      <BookingConfirmedContainer>
        <Heading level={2}>
          {isRooState ? "Booking confirmed!" : "Account was successfully created"}
        </Heading>
        <img src={bookingConfirmedImg} />
        <div>
          <Heading level={5}>
            {isRooState
              ? "Your profile application is under review."
              : "Unfortunately, Roo isn’t available in your area yet."}
          </Heading>
          <Text>
            {isRooState
              ? "Once you have spoken with our team member and your account has been approved, you will receive an email indicating your full access to begin posting shifts and fulfilling your scheduling needs. We can’t wait to chat with you soon!"
              : "Thank you for signing up with Roo! Unfortunately, we’re not available in your area yet. But don’t worry - we’re expanding quickly, and may be coming to your area soon. Be on the lookout for an email as we’ll be reaching out once we’re live!"}
          </Text>
          <Link href="https://www.roo.vet/veterinary-hospitals">Back to Roo</Link>
        </div>
      </BookingConfirmedContainer>
    </PageContainer>
  );
}

// eslint-disable-next-line no-restricted-exports
export default RegistrationComplete;
